import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { actualizarDatosParaMuiTable, updateDatosParaMuiTable } from '../actions/MenuDeMuestrasTablaActions'
import { MenuDeMuestrasTablaView } from '../components/MenuDeMuestrasTablaView'
import { COLUMNS_MENU_DE_MUESTRAS } from '../actions/constantesMenuDeMuestrasTabla'
import FormListadoConsulta from '../components/FormListadoConsulta'
import { FORM_LISTADO_MUESTRAS_ENVIADAS } from '../../../../../config/forms'

class MenuDeMuestrasTabla extends Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount () {
    const data = []
    this.props.updateDatosParaMuiTable({
      columns: COLUMNS_MENU_DE_MUESTRAS,
      data,
      title: '',
      isLoading: false,
      extraOptions: { customToolbar: null, print: false, filter: true, rowsPerPage: 1000, rowsPerPageOptions: [100, 500, 1000] }
    })
  }

  handleSubmit () {
    this.props.actualizarDatosParaMuiTable(this.props.destroy)
  }

  render () {
    return (
      <>
        <h3>Consulta de Muestras enviadas a la Cámara</h3>
        <FormListadoConsulta handleSubmit={this.handleSubmit} />
        <MenuDeMuestrasTablaView />
      </>
    )
  }
}
const mapActionsToProps = {
  actualizarDatosParaMuiTable,
  updateDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)
export default withRedux(reduxForm({ form: FORM_LISTADO_MUESTRAS_ENVIADAS })(MenuDeMuestrasTabla))
